import { __spreadArray } from '../../../../../_virtual/_tslib.js';
import { file_mime_types, images_format_keys } from '../../File/constants/File.constants.js';

var IMAGE_CDN_FORMATS = {
    AUTO: "auto",
    AVIF: images_format_keys.avif,
    JPEG: images_format_keys.jpeg,
    JPG: images_format_keys.jpg,
    PNG: images_format_keys.png,
    WEBP: images_format_keys.webp,
    SVG: images_format_keys.svg,
    TIFF: images_format_keys.tiff,
};
var ACCEPTED_IMAGES_FORMAT_IN_OPTIMIZATING_CDN = __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], file_mime_types[images_format_keys.png], true), file_mime_types[images_format_keys.jpeg], true), file_mime_types[images_format_keys.jpg], true), file_mime_types[images_format_keys.avif], true), file_mime_types[images_format_keys.svg], true), file_mime_types[images_format_keys.tiff], true), file_mime_types[images_format_keys.webp], true);

export { ACCEPTED_IMAGES_FORMAT_IN_OPTIMIZATING_CDN, IMAGE_CDN_FORMATS };
//# sourceMappingURL=ExlyImage.constants.js.map
